var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"oneTrust",class:{ 'oneTrust-reset': _vm.dataResetStyles }},[_c('div',{staticClass:"otnotice",attrs:{"id":_vm.dataDivId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }